
export default function Header({ onConsultClick }: { onConsultClick: () => void }) {
  return null;
}
